import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { getIsInitialAuthCheck, markInitialAuthCheckComplete } from './services/api';

// Handle unhandled promise rejections (which trigger React error overlay)
// Use the shared isInitialAuthCheck state from api.ts for synchronization
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const is401Error = error?.response?.status === 401 || 
                    error?.message?.includes('401') ||
                    error?.message?.includes('Request failed with status code 401') ||
                    error?.message?.includes('Unauthorized - expected during initial auth check') ||
                    error?.isExpected === true;
  
  // Suppress 401 errors during initial auth check
  // Use the shared state from api.ts to stay synchronized
  if (getIsInitialAuthCheck() && is401Error) {
    // Prevent the error from showing in React's error overlay
    event.preventDefault();
    event.stopPropagation();
    // Silently handle - this is expected when user is not logged in
    return false;
  }
  
  // Let other errors through normally (don't prevent default)
}, true); // Use capture phase

// Also suppress React's error overlay for expected errors
if (process.env.NODE_ENV === 'development') {
  const originalError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    const isExpected401 = error?.message?.includes('Unauthorized - expected during initial auth check') ||
                         error?.message?.includes('Request failed with status code 401') ||
                         (error as any)?.isExpected === true;
    
    // Use the shared state from api.ts to stay synchronized
    if (getIsInitialAuthCheck() && isExpected401) {
      // Suppress expected 401 errors
      return true; // Prevent default error handling
    }
    
    // Let other errors through
    if (originalError) {
      return originalError(message, source, lineno, colno, error);
    }
    return false;
  };
}

// Mark initial auth check as complete after a short delay
// This ensures both the API interceptor and global error handlers are synchronized
setTimeout(() => {
  markInitialAuthCheckComplete();
}, 3000);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);